/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status__ExpiredInputs */

const en_payment_status__expired = /** @type {(inputs: Payment_Status__ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Payment_Status__ExpiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const payment_status__expired = /** @type {((inputs?: Payment_Status__ExpiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status__ExpiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_payment_status__expired(inputs)
});